import InnerComponent from '@Components/Sales/IncomingPayments/IncomingPaymentsList';
import orgContainer from '@Components/AppContainer';

const IncomingPaymentsList = () => ((orgContainer(InnerComponent)));

export default IncomingPaymentsList;
